import { NgClass, NgFor, NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  AccordionModule,
  Link,
  StickyNavbarModule
} from '@com-delta-idp/mnx-ui-kit';
import { Section } from '../../models/menu.interfaces';
import { SectionHeaderComponent } from '../section-header/section-header.component';
import { SectionItemComponent } from '../section-item/section-item.component';

@Component({
  selector: 'idp-section',
  imports: [
    AccordionModule,
    SectionHeaderComponent,
    SectionHeaderComponent,
    SectionItemComponent,
    StickyNavbarModule,
    NgIf,
    NgFor,
    NgClass
  ],
  standalone: true,
  templateUrl: './section.component.html',
  styleUrls: ['./section.component.scss']
})
export class SectionComponent {
  @Input() details: Section = {} as Section;
  @Output() listItem: EventEmitter<Link> = new EventEmitter<Link>();
}
